/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_AnimationInputs */

const en_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable animation`)
};

const es_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar animación`)
};

const fr_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'animation`)
};

const de_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animation aktivieren`)
};

const ja_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アニメーションを有効にする`)
};

const zh_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用动画`)
};

const ar_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل التأثيرات`)
};

const id_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan animasi`)
};

const it_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita animazione`)
};

const ru_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить анимацию`)
};

const pt_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar animação`)
};

const ko_enable_animation = /** @type {(inputs: Enable_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`애니메이션 활성화`)
};

/**
* | output |
* | --- |
* | "Enable animation" |
*
* @param {Enable_AnimationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_animation = /** @type {((inputs?: Enable_AnimationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_AnimationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_animation(inputs)
	if (locale === "es") return es_enable_animation(inputs)
	if (locale === "fr") return fr_enable_animation(inputs)
	if (locale === "de") return de_enable_animation(inputs)
	if (locale === "ja") return ja_enable_animation(inputs)
	if (locale === "zh") return zh_enable_animation(inputs)
	if (locale === "ar") return ar_enable_animation(inputs)
	if (locale === "id") return id_enable_animation(inputs)
	if (locale === "it") return it_enable_animation(inputs)
	if (locale === "ru") return ru_enable_animation(inputs)
	if (locale === "pt") return pt_enable_animation(inputs)
	return ko_enable_animation(inputs)
});